module.exports = __webpack_public_path__ + "img/vitejs-svgrepo-com.275eb728.svg";